module.exports = __webpack_public_path__ + "static/media/SPORT.5238c148.png";